import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useState, useEffect} from 'react';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { filtrarBases } from '../../../actions/basesCertActions';
import useSelectProyecto from '../../../hooks/useSelectProyectos';
import DatePicker from "react-datepicker";
import * as moment from 'moment';
import { avisoError } from '../../components/AvisosMensajes/MensajesSwalf';


const FormularioFiltro = () => {
const dispatch = useDispatch();
const {usuario} = useSelector(state=>state.usuario)
const [proyecto, SelectProyecto] = useSelectProyecto(null)
const [fechaFiltro, setFechaFiltro] = useState(null)
const [fechaFiltroHasta, setFechaFiltroHasta] = useState(null)



const traerDatos = () =>{
  if(fechaFiltro!==null && fechaFiltroHasta!==null)
  { 
    const datosFiltro = {
      fechaFiltroDesde: fechaFiltro ? moment(fechaFiltro).format('YYYY-MM-DD') : null,
      fechaFiltroHasta: fechaFiltroHasta ? moment(fechaFiltroHasta).format('YYYY-MM-DD') : null,
      producto: proyecto ? proyecto.id_proyecto : null,
    }

  // console.log(datosFiltro)

    dispatch(filtrarBases(datosFiltro,usuario))
  }
  else
  {
    avisoError("Debe seleccionar un rango de fecha por lo menos.")
  }
  
}

 return (
 
    <div className="box">
     <div className="box-header with-border">
                  <h5
                      style={{ color: "#434343" }}
                    >
                    <FontAwesomeIcon icon={faSearch} /> Acciones de Filtro
                  </h5>
                
                </div>
      <div className="row p-2">
        <div className="col-9 mb-2">
          <label htmlFor="">Producto:</label>
          <SelectProyecto/>
        </div>
        <div className="col-4">
          <label htmlFor="">Desde:</label>
          <DatePicker
                selected={fechaFiltro}
                onChange={(date) =>setFechaFiltro(date)}
                selectsStart
                dateFormat="dd/MM/yyyy"
                autoComplete="off"
                name="fechaFiltro"
                startDate={fechaFiltro}
                className="form-control"
                endDate={fechaFiltroHasta}
              />
        </div>
        <div className="col-4">
          <label htmlFor="">Hasta:</label>
          <DatePicker
                selected={fechaFiltroHasta}
                onChange={(date) =>setFechaFiltroHasta(date)}
                selectsStart
                dateFormat="dd/MM/yyyy"
                className="form-control"
                name="fechaFiltroHasta"
                startDate={fechaFiltro}
                endDate={fechaFiltroHasta}
                minDate={fechaFiltro}
                autoComplete="off"
              />
        </div>
        <div className="col-12 pt-4">
        <button className="btn btn-primary" onClick = {traerDatos} >Consultar</button>
        </div>
      </div>
    </div>
  
  
    );
};

export default FormularioFiltro;
